<div class="app-tabs">
  <app-tabs-with-content *ngIf="!hideTabs" [tabs]="tabs" [selectedTab]="selectedTab"
  (onSelectTab)="navigateToTab($event)">
  </app-tabs-with-content>
</div>

@if (selectedTab === Tab.Profile)
{
<app-profile-information *ngIf="user" [userName]="user.fullName" [userRole]="user.role" [userRegion]="user.country" [userIconClass]="'bi bi-person-circle'">
</app-profile-information>

<div class="row">
  <div class="col-md-12">
    <app-case-form-section-container [title]="'title.personal_info.title' | translate" [iconClass]="'bi bi-person'">
      <app-personal-information-form *ngIf="user" [userData]="user"></app-personal-information-form>
    </app-case-form-section-container>
  </div>

  <div class="col-md-6" [hidden]="true">
    <app-case-form-section-container [title]="'title.notifications.title' | translate" [iconClass]="'bi bi-bell'">
      <app-notifications-form *ngIf="user" [notificationSettings]="user.notificationSettings"></app-notifications-form>
    </app-case-form-section-container>
  </div>
</div>

<div class="form-actions">
  <button type="button" class="btn btn-secondary" (click)="discardChanges()" [disabled]="!isFormDirty">
    {{ 'buttons.discard_changes' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="saveChanges()" [disabled]="!isFormDirty">
    {{ 'buttons.save_changes' | translate }}
  </button>
</div>
}

@if (selectedTab === Tab.News)
{
<div class="row">
  <app-news-profile [hideTabs]="hideTabs" (toggleTabs)="toggleTabsVisibility($event)"></app-news-profile>

</div>
}

@if (selectedTab === Tab.ConfigureInformation)
{
<div class="row">
  <div class="col-12">
    <app-configure-information></app-configure-information>
  </div>
</div>
}

@if (selectedTab === Tab.ImpersonateUser)
{
<div class="row">
  <div class="col-12">
    <app-impersonate-user></app-impersonate-user>
  </div>
</div>
}
